import { Outlet } from "react-router-dom";
import Header from "../partials/Header/Header";
import NavBar from "../partials/NavBar/NavBar";
import SidebarPage from "../partials/Sidebar/Sidebar";
import { useState } from "react";
import { useAuth } from "@conductor/context/AuthContext";
import { useLayoutAppContext } from "@conductor/context/LayoutAppContext";
import ConnectionBanner from "@shared/componets/feedback/ConnectionBanner/ConnectionBanner";
import OfflineSync from "../partials/OfflineSync/OfflineSync";

const AppLayout = () => {
    const { userData, loadingAuth } = useAuth();
    const [sidebarActive, setSidevbarActive] = useState(false);
    const { nameUser, navbar } = useLayoutAppContext();

    return (<>
        {/* Banner global de conexión: fijo arriba de todo, solo visible offline/al reconectar */}
        <ConnectionBanner />
        {/* Drenado global de la cola offline (desde cualquier pantalla) + indicador de pendientes */}
        <OfflineSync />
        <Header {...userData} loading={loadingAuth} active={nameUser} />
        <Outlet />
        <SidebarPage setSidevbarActive={setSidevbarActive} sidebarActive={sidebarActive} />
        <NavBar setSidevbarActive={setSidevbarActive} active={navbar} />
    </>);
};

export default AppLayout;